// extracted by mini-css-extract-plugin
export default {"component":"book-cover__p76ar","bookCover":"book-cover__UpLdg","highlight":"book-cover__WB6SB","default":"book-cover__UhVWu","bookType":"book-cover__EGtb6"};